import { ParsedUrlQuery } from 'querystring';
import { Offer, Property, Attributes, Paymentsoptionstype, Product } from '../../../types/page';
import { Impression } from '../../../types/datalayer/pageview';
import { SelectedAggregation } from '../../../types/page';
import { parsedQsType } from '../../../types/datalayer/datalayer';
import { Dimensions } from '../../../types/dimensions';

export const getStampPrime = (offers: Offer[]): boolean =>
  offers?.some((offer: Offer) => offer?.stamps?.result?.includes('PRIME'));

export const getSellers = (offerQuantity = 0): string => {
  switch (offerQuantity) {
    case 0:
      return 'Nenhum Seller';
    case 1:
      return '1 Seller';
    default:
      return '2 ou mais Sellers';
  }
};

export const getMarca = (atributes: Attributes): string | undefined => {
  const marca = atributes.properties.find(({ name }: Property): boolean => name === 'Marca');
  return marca && marca.value.replace(/,/g, '-').trim();
};

export const getOfferClassificationType = (offers: Offer[], classificationType: string): string => {
  switch (classificationType) {
    case 'MIXED':
      return `Misto ${getSellerType(offers?.[0])}`;
    case 'MARKETPLACE':
      return 'Exclusivo Marketplace';
    case 'B2W':
      return 'Exclusivo B2C';
    default:
      return '';
  }
};

export const getSellerType = (offer: Offer | undefined): string =>
  offer ? (offer.seller.name === 'B2W' ? 'B2C' : 'Marketplace') : '';

export const getSellerName = (offer: Offer | undefined, sellerName: string): string =>
  offer ? (getSellerType(offer) === 'B2C' ? sellerName.toLowerCase() : offer.seller.name.toLowerCase().trim()) : '';

export const formatFilters = (filters: SelectedAggregation[]): string => {
  const formatted = filters.map(element => `${element.aggregationTitle}: ${element.title}`) || [];

  return formatted.join('|');
};
export const searchImpressions = (productList: Product[], isMarketSelected: boolean | undefined): Impression[] =>
  productList.map(({ id, ads }, i) => {
    const adsId = ads?.id || '';
    const dimensions = {} as Dimensions;
    const impression = {
      position: i + 1,
      id: id,
      list: 'Grid Busca',
    };

    if (adsId) {
      dimensions.dimension145 = adsId;
    }

    if (isMarketSelected) {
      dimensions.dimension38 = 'Filtro Mercado';
    }

    return { ...impression, ...dimensions };
  });

export const getMeioPagamento = (paymentOptions = {} as Paymentsoptionstype): string =>
  Object.keys(paymentOptions)
    .reduce((parc: string[], currentKey: string) => {
      const payment = paymentOptions[currentKey];
      if (!payment) {
        parc.push(':|()|');
        return parc;
      }

      const price = currentKey === 'BOLETO' ? payment.price : payment.minQuantity && payment.minQuantity[0].value;
      const priceParcWithoutFees = payment.maxQuantity ? payment.maxQuantity[0].total : price;
      const maxParcWithoutFees = payment.maxQuantity ? payment.maxQuantity[0].quantity : 1;
      const cashback = payment.cashback && payment.cashback.value;

      parc.push(`${currentKey}:${price}|${priceParcWithoutFees}(${maxParcWithoutFees})|${cashback}`);

      return parc;
    }, [])
    .join(',');

export const getEventName = (type: string): string =>
  `pageview_${['home', 'busca', 'produto', 'newsletter'].includes(type) ? type : 'outros'}`;

export const getPfm = (parsedQs: parsedQsType | ParsedUrlQuery): string => {
  const {
    pfm_page: pfmPage,
    pfm_pos: pfmPos = '',
    pfm_type: pfmType,
    nm_ranking_rec: numberRankingRec,
    pfm_index: pfmIndex,
    'DCSext.recom': DCSrecom = '',
    nm_origem: nmOrigem = '',
  } = parsedQs as parsedQsType;

  const index = pfmIndex ? Number(pfmIndex) + 1 : numberRankingRec;
  const origem = nmOrigem.split('-');
  const page = origem[0] ? origem[0].split('.')[0] : pfmPage;
  const recom = origem[1] ? origem[1] : DCSrecom.split('-')[1];
  const pos = pfmPos.split('.')[1];

  const pfm = `${pfmType}|${page}|${recom}|${index}|${pos}`;
  return pfm;
};

export const getAggregation = (arr: any[], origin: string) =>
  arr.find(({ aggregationId }: { aggregationId: string }) => aggregationId === origin);

export const hasAggregationValue = (arr: any[], check: string) =>
  arr?.some(({ params }: { params: { value: string } }) => params?.value === check);

export const hasSelectedAggregation = (arr: any[], check: string) => arr?.some(({ value }) => value === check);

export const getSellerLoyaltyString = (badge: string, salesVolume: boolean) => {
  const badgeInlowerCase = badge?.toLocaleLowerCase();

  if (!salesVolume) {
    return 'seller-loja-nova';
  }

  const object: Record<string, string> = {
    'loja oficial': 'seller-loja-diamante',
    'loja top 1': 'seller-loja-ouro',
    'loja top 2': 'seller-loja-prata',
    'loja top 3': 'seller-loja-bronze',
  };

  return object[badgeInlowerCase] ?? 'seller-loja-sem-medalha';
};
